module.exports = __webpack_public_path__ + "img/73.1f87ce5a.jpg";